import React from 'react'
import './styles.css'




const BannerDetail = ({name, specialist, urlImage, pathImage, setModal}) => {

    
  return (
    <div className='contain-banner-detail-specialist'>
        <section className='background-banner-specialist-detail'>
            <div className='info-banner-detail-specialist'>
                <div>
                    <img src={`${urlImage}${pathImage}`} alt="" />
                </div>
                <div className='info-banner-detail-specialist-second'>
                    <h1>{name}</h1>
                    <p>
                        {
                            specialist.map((item,key)=>{
                                return(
                                    <span key={key}>{item.name}, </span>
                                )
                            })
                        }
                    </p>
                    <div className='contain-buttons-banner-specialist-detail'>
                        <button onClick={()=>setModal(true)}>
                            Pedir cita
                        </button>
                    </div>
                </div>
            </div>
        </section>

    </div>
  )
}

export default BannerDetail